export default "__VITE_ASSET__yyDTpf3o__"